export function isWebGLSupported(): boolean {
  try {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl') ||
      canvas.getContext('experimental-webgl') ||
      canvas.getContext('webgl2');
    const isSupported =
      !!gl &&
      (gl instanceof WebGLRenderingContext ||
        gl instanceof WebGL2RenderingContext);
    return isSupported;
  } catch (e) {
    return false;
  }
}

export function displayWebGLNotSupportedMessage() {
  const i18n = {
    en: 'WebGL not supported.\nPlease try a different browser.',
    ja: 'WebGLがサポートされていません。\n別のブラウザをお試しください。',
  };
  const userLanguage = navigator.language || navigator.languages[0] || 'ja';
  const locale = userLanguage.startsWith('en') ? 'en' : 'ja';

  const message = document.createElement('div');
  message.style.position = 'absolute';
  message.style.left = '0';
  message.style.top = '0';
  message.style.width = '100%';
  message.style.height = '100%';
  message.style.backgroundColor = 'black';
  message.style.color = 'white';
  message.style.display = 'flex';
  message.style.justifyContent = 'center';
  message.style.alignItems = 'center';
  message.style.textAlign = 'center';
  message.style.fontSize = '20px';
  message.style.fontFamily = 'Arial';
  message.style.zIndex = '10000';
  message.innerText = i18n[locale];
  document.body.appendChild(message);
}
